var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtn4Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_User_Line",
    "data-name": "icons/User/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 16.667,
    viewBox: "0 0 16.667 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.031,1.666c-1.037.039-1.794.094-2.336.148a.932.932,0,0,0-.911.825,19.219,19.219,0,0,0-.118,2.3,19.219,19.219,0,0,0,.118,2.3.932.932,0,0,0,.911.825c1.007.1,2.747.2,5.638.2s4.631-.1,5.638-.2a.932.932,0,0,0,.911-.825A19.219,19.219,0,0,0,15,4.944a19.219,19.219,0,0,0-.118-2.3.932.932,0,0,0-.911-.825c-.543-.054-1.3-.109-2.336-.148A.833.833,0,1,1,11.7,0c1.064.04,1.856.1,2.438.155a2.6,2.6,0,0,1,2.4,2.282,20.854,20.854,0,0,1,.13,2.507,20.853,20.853,0,0,1-.13,2.507,2.6,2.6,0,0,1-2.4,2.282c-1.079.107-2.877.212-5.8.212s-4.724-.1-5.8-.212A2.6,2.6,0,0,1,.13,7.451,20.853,20.853,0,0,1,0,4.944,20.854,20.854,0,0,1,.13,2.437,2.6,2.6,0,0,1,2.53.156C3.113.1,3.9.041,4.969,0a.833.833,0,1,1,.063,1.665Z",
    transform: "translate(6.722 16.667) rotate(-90)",
    fill: "#777e90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M4.339,7.256a.833.833,0,0,1-1.179,0L.244,4.339a.833.833,0,0,1,0-1.179L3.161.244A.833.833,0,1,1,4.339,1.423L2.845,2.917h7.988a.833.833,0,0,1,0,1.667H2.845L4.339,6.077A.833.833,0,0,1,4.339,7.256Z",
    transform: "translate(0 4.583)",
    fill: "#777e90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn4Icon);
export default __webpack_public_path__ + "static/media/btn4icon.23ff14b288249bd007c89f4fa0fe6854.svg";
export { ForwardRef as ReactComponent };